import React from "react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Search, Calendar, Bike, Shield, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const STEPS = [
  { n: "01", icon: Search, t: "Search & filter", d: "Pick your city, choose your dates, browse 12K+ bikes by category, fuel & price." },
  { n: "02", icon: Calendar, t: "Book in seconds", d: "Confirm pickup point, plan and dates. We calculate the best price instantly." },
  { n: "03", icon: Bike, t: "Ride away", d: "Pick up at our hub or get it delivered. Helmet & insurance included." },
  { n: "04", icon: Shield, t: "Return easy", d: "Drop the bike back, deposit refunded automatically. Done." },
];

const HowItWorks = () => (
  <div className="min-h-screen bg-[#F8F9FA]">
    <Navbar />
    <div className="max-w-5xl mx-auto px-5 md:px-8 py-20">
      <p className="text-[10px] uppercase tracking-widest font-bold text-[#2D7FF9] font-mono-num">— PROCESS</p>
      <h1 className="font-display font-extrabold text-5xl md:text-6xl mt-4 tracking-tight">How eBikeGo works.</h1>
      <p className="text-gray-600 mt-4 max-w-xl text-lg">From browsing to riding, in under two minutes. Here's the magic behind the scenes.</p>

      <div className="grid md:grid-cols-2 gap-5 mt-16">
        {STEPS.map((s, i) => (
          <div key={i} className="card-premium p-8">
            <div className="flex items-start justify-between">
              <span className="font-mono-num font-bold text-[#3DDC97] text-sm">{s.n}</span>
              <s.icon className="text-gray-300" size={28} />
            </div>
            <h3 className="font-display font-bold text-2xl mt-6 tracking-tight">{s.t}</h3>
            <p className="text-gray-600 mt-3 leading-relaxed">{s.d}</p>
          </div>
        ))}
      </div>

      <Link to="/bikes" data-testid="how-it-works-cta" className="btn-primary mt-12 inline-flex">Start browsing <ArrowRight size={16} /></Link>
    </div>
    <Footer />
  </div>
);

export default HowItWorks;
